module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAVBAMAAACwDgOmAAAAAXNSR0IB2cksfwAAAA9QTFRFAAAAAAAAAAAAAAAAAAAATw7njQAAAAV0Uk5TAL///Sc9+kYLAAAAPklEQVR4nGMQEmBgYFRkYGAAMhSUgIAJiBUUGIRMgOLKDgwgBhMDFDAxUMQG2QUGILsUoGyoXRBx6tpFwF8ASI0GzcT/orUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/lay-transform_copy.png
// module id = 844
// module chunks = 0